export const en = {
    'adjustments-rate': 'Bids shown are before adjustments'
};
